import React from 'react';
import { Upload, Icon } from 'antd';
import FormItem from '../FormItem/FormItem';
import { formConfig } from '../../../../config';

const UploadDocField = ({ form, fileList, setFileList }) => {
  const beforeUpload = (file) => {
    setFileList([file]);
    return false;
  };

  return (
    <FormItem>
      {form.getFieldDecorator('file')(
        <Upload.Dragger
          name={formConfig.fieldNames.file}
          fileList={fileList}
          multiple={false}
          beforeUpload={beforeUpload}
          onRemove={() => setFileList([])}
        >
          <Icon
            type="file-add"
            theme="outlined"
          />{' '}
          перетащите файл сюда, или нажмите, чтобы выбрать
        </Upload.Dragger>
      )}
    </FormItem>
  );
};

export default UploadDocField;
